import { useEffect, useState } from "react";
import moment from "moment-timezone";

const LiveFromNow = ({
  date,
  timezone = process.env.REACT_APP_TIMEZONE,
  interval = 1000,
}) => {
  const [timeText, setTimeText] = useState("");

  useEffect(() => {
    setTimeText(moment(date).tz(timezone).fromNow());

    const timer = setInterval(() => {
      setTimeText(moment(date).tz(timezone).fromNow());
    }, interval);

    return () => clearInterval(timer);
  }, [date, timezone, interval]);

  return <span>{timeText}</span>;
};

export default LiveFromNow;
